const initialState = {
    translations: [],
  };
  
  const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
      case "setTranslations":
        return {
          ...state,
          translations: payload,
        };
  
      default:
        return state;
    }
  };
  
  export default reducer;
  